<template>
  <div :id="shopifyData.sectionId" class="rich-text-section" :style="sectionStyles">
    <div class="container">
      <div class="container_content" :style="contentWidth">
        <h2 class="rich-text_title">
          {{ shopifyData.title }}
        </h2>
        <p class="rich-text_Info">
          {{ shopifyData.description }}
        </p>
        <div class="footerContent">
          <span class="rich-text_btnLabel">{{ shopifyData.buttonLabel }}</span>
          <span class="rich-text_downIcon">
            <svg
              width="19"
              height="11"
              viewBox="0 0 19 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.4458L9.57143 9.88454L18.1429 1.4458"
                stroke="white"
                stroke-width="1.75"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth, // Reactive window width
    };
  },
  computed: {
    sectionStyles() {
      return {
        paddingTop: `${this.windowWidth > 768 ? this.shopifyData.secDeskPaddingTop : this.shopifyData.secMobPaddingTop}px`,
        paddingBottom: `${this.windowWidth > 768 ? this.shopifyData.secDeskPaddingBottom : this.shopifyData.secMobPaddingBottom}px`,
        background:
          this.windowWidth > 768
            ? `url(${this.shopifyData.desktopBannerBg})`
            : `url(${this.shopifyData.mobBannerBg})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      };
    },
    contentWidth() {
      return {
        maxWidth: `${this.shopifyData.contentWidth}px`,
      };
    },
  },
  mounted() {
    // Add event listener for window resizing
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.rich-text-section {
  background-position: center !important;
  background-repeat: no-repeat;
  background-size: cover;
}

.container {
  padding: 0 40px;
}

.container_content {
  width: 100%;
  margin: 0 auto;
}

.rich-text_title {
  font-family: 'Helvetica', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 21.98px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #fff;
}

.rich-text_Info {
  font-family: 'PP Editorial New', sans-serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 200;
  line-height: 20.48px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #fff;
  margin: 60px 0 47px;
}

.rich-text_btnLabel {
  font-family: 'Helvetica', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.32px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #fff;
}

.footerContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 17px;
}
</style>
